/**
 * Created by PJPERF on 05.04.2017.
 */
import React from 'react'
import auth from '../api/auth';

class LogoutForm extends React.Component{
    componentWillMount () {
        auth.logout();
        this.props.history.replace('/login');
    }
    render() {
        return null;
    }
}

export default LogoutForm;